@import '../../table/pageWithTable.module.scss';

.container {
  > .header {
    margin-top: 0;
  }
}

.descriptionCol {
  max-width: 200px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.tagsCol {
  max-width: 150px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.actionCol {
  white-space: nowrap;
}
